import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f518a1fc")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_header = _resolveComponent("el-header")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _withDirectives(_createVNode(_component_el_header, null, {
        default: _withId(() => [
          _renderSlot(_ctx.$slots, "header", { class: "header-wrap" })
        ]),
        _: 3
      }, 512), [
        [_vShow, _ctx.$slots.header]
      ]),
      _createVNode(_component_el_main, null, {
        default: _withId(() => [
          _renderSlot(_ctx.$slots, "table", { class: "table" })
        ]),
        _: 3
      }),
      _createVNode(_component_el_footer, null, {
        default: _withId(() => [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _createVNode(_component_el_row, { style: {"width":"100%"} }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { style: {"display":"flex","justify-content":"center"} }, {
                  default: _withId(() => [
                    _createVNode(_component_el_pagination, {
                      background: "",
                      layout: _ctx.layout,
                      total: Number(_ctx.total),
                      "page-size": Number(_ctx.pageSize),
                      "page-sizes": [10, 20, 30, 40,50,100],
                      "current-page": Number(_ctx.curPage),
                      "onUpdate:pageSize": _ctx.sizeChange,
                      "onUpdate:currentPage": _ctx.currentChange
                    }, null, 8, ["layout", "total", "page-size", "current-page", "onUpdate:pageSize", "onUpdate:currentPage"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      })
    ]),
    _: 1
  }))
})